import { useApp } from 'contexts/app';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { SYSTEM_ASSIGNMENT_DEFAULTS } from 'utils/assignmentDefaults';
import AssignmentSettingsPanel from './AssignmentSettingsPanel';
import { AssignmentSettingToggleCard } from './AssignmentSettingsPanelControls';
import InlineCommentsSettingsForm from './InlineCommentsSettingsForm';

const AssignmentInlineCommentsPanel = ({ form, setForm, isEditable }) => {
    const { isInlineCommentsFeatureDisabled } = useApp();
    const { t } = useTranslation('assignment');
    const id = useId();
    const enabled = form.aiInlineCommentsEnabled && !isInlineCommentsFeatureDisabled;
    const disabled = !isEditable || !enabled;
    const handleChange = (changes) => {
        if (disabled) return;
        setForm((current) => {
            const value = {
                ...SYSTEM_ASSIGNMENT_DEFAULTS.inlineCommentsSettings,
                ...current.inlineCommentsSettings,
                inlineCommentsCustomContext: current.inlineCommentsCustomContext || '',
            };
            const next = typeof changes === 'function' ? changes(value) : { ...value, ...changes };
            const { inlineCommentsCustomContext, ...inlineCommentsSettings } = next;
            return { ...current, inlineCommentsSettings, inlineCommentsCustomContext };
        });
    };
    return (
        <AssignmentSettingsPanel
            enabled={enabled}
            toggle={
                <AssignmentSettingToggleCard
                    title={t(
                        'inline-comments-section.automatically-generate-inline-comments',
                        'Automatically generate inline comments?'
                    )}
                    description={t(
                        'inline-comments-section.inline-comments-description',
                        "Inline comments are distinct from overall feedback. They provide contextual insights directly on the student's work tied to feedback and/or grading suggestions. If this option is disabled, you will still be able to add your own comments manually."
                    )}
                    checked={enabled}
                    disabled={!isEditable}
                    restricted={isInlineCommentsFeatureDisabled}
                    onChange={(value) => setForm((current) => ({ ...current, aiInlineCommentsEnabled: value }))}
                />
            }
        >
            <InlineCommentsSettingsForm
                form={{
                    ...SYSTEM_ASSIGNMENT_DEFAULTS.inlineCommentsSettings,
                    ...form.inlineCommentsSettings,
                    inlineCommentsCustomContext: form.inlineCommentsCustomContext || '',
                }}
                handleChange={handleChange}
                disabled={disabled}
                idPrefix={`${id}-`}
            />
        </AssignmentSettingsPanel>
    );
};
export default AssignmentInlineCommentsPanel;
